// Solicitud al proveedor (Logística 2, nivel 2 "Quién va y camareros"): la
// frase resumen de camareros ("No hacen falta aparte. El servicio de camarero
// (3 h) lo hace Brandon." o una línea por menú que los lleva), el personal de
// fuera con "Pedir a proveedor" / "Ver la solicitud" (la orden de personal
// extra de siempre) y "Abrir la solicitud al proveedor" (la misma orden, con
// la sugerencia ya rellena; no cambia el número de camareros). Si ya hay
// solicitud (aunque sea un borrador, salvo anulada o cancelada), un aviso:
// manda en el coste del presupuesto (costes_presupuesto: orden vigente >
// Quién va > estimado). El número de camareros se cambia en el bloque
// "Personal del menú" (quienVa/BloquesQuienVa, variante l2).
import React from 'react';
import { resumenCamareros } from '../../../utils/logistica2';
import { botonPrincipal, botonSecundario, enlace, enlacePequeno } from './estilos';

const plural = (n, uno, varios) => `${n} ${n === 1 ? uno : varios}`;

// Estados de la orden de personal extra que ya no cuentan en el coste
const ESTADOS_NO_VIGENTES = ['anulada', 'cancelada'];
const ETIQUETA_ESTADO = { borrador: 'borrador', enviada: 'enviada', confirmada: 'confirmada' };

const CamarerosQuienVa = ({
  qv, nombre = '', hayOrdenExtra = false, personasOrdenExtra = 0, estadoOrdenExtra = null, onAbrirSolicitud,
}) => {
  const { raiz, jornadas, multi, modo, externosCalculo } = qv;
  if (!raiz) return null;
  const grupos = multi ? jornadas.map(x => ({ id: x.j.id, etiqueta: x.j.etiqueta, est: x.est })) : [{ id: 'raiz', etiqueta: null, est: raiz }];
  const desglose = [
    externosCalculo.camareros > 0 ? plural(externosCalculo.camareros, 'camarero', 'camareros') : null,
    externosCalculo.extras > 0 ? plural(externosCalculo.extras, 'extra', 'extras') : null,
  ].filter(Boolean).join(' + ');
  const estado = String(estadoOrdenExtra || 'borrador').toLowerCase();
  const ordenManda = hayOrdenExtra && !ESTADOS_NO_VIGENTES.includes(estado);

  return (
    <div className="flex flex-col gap-2" data-testid="l2-camareros">
      {grupos.map(({ id, etiqueta, est }) => {
        const r = resumenCamareros(est.filas, nombre || (modo === 'extra' ? 'el extra' : ''));
        return (
          <div key={id} className="flex flex-col gap-0.5" data-testid={`l2-camareros-grupo-${id}`}>
            {etiqueta && <span className="text-xs font-semibold text-[#5B6B64]">{etiqueta}</span>}
            {r.hacenFalta ? (
              <>
                {r.lineas.map(l => <p key={l.clave} className="text-sm text-[#16221D]" data-testid="l2-camareros-linea">{l.texto}</p>)}
                {r.texto && <p className="text-sm text-[#33443C]">{r.texto}</p>}
              </>
            ) : (
              <p className="text-sm text-[#16221D]" data-testid="l2-camareros-texto">{r.texto}</p>
            )}
          </div>
        );
      })}

      {/* Personal externo: la orden de personal extra de siempre */}
      {onAbrirSolicitud && (externosCalculo.total > 0 ? (
        <div className="flex flex-wrap items-center justify-between gap-2 rounded-lg bg-[#F7F9F8] px-3 py-2 text-sm" data-testid="l2-externos">
          <span>
            Personal de fuera: <strong>{plural(externosCalculo.total, 'persona', 'personas')}</strong>
            {desglose ? ` (${desglose})` : ''}{multi ? ' en la jornada que más lleva' : ''}.
            {' '}{hayOrdenExtra ? `Solicitud hecha (${plural(Number(personasOrdenExtra) || 0, 'persona', 'personas')}).` : 'Falta pedirlo al proveedor.'}
          </span>
          <button type="button" onClick={onAbrirSolicitud} className={hayOrdenExtra ? botonSecundario : botonPrincipal} data-testid="l2-externos-solicitud">
            {hayOrdenExtra ? 'Ver la solicitud' : 'Pedir a proveedor'}
          </button>
        </div>
      ) : (
        <button type="button" onClick={onAbrirSolicitud} className={`self-start ${enlacePequeno}`} data-testid="l2-externos-opcional">
          {hayOrdenExtra
            ? `Ver la solicitud de personal de fuera (${plural(Number(personasOrdenExtra) || 0, 'persona', 'personas')})`
            : 'Pedir personal de fuera (opcional)'}
        </button>
      ))}

      {/* La solicitud hecha manda en el coste: si cambian los camareros, hay que actualizarla */}
      {ordenManda && (
        <p className="rounded-[10px] border px-3 py-2 text-sm bg-[#FDF0DC] border-[#F4D9AE] text-[#7A3A06]" data-testid="l2-solicitud-manda">
          La solicitud al proveedor ({ETIQUETA_ESTADO[estado] || estado}, {plural(Number(personasOrdenExtra) || 0, 'persona', 'personas')}) manda en el coste del presupuesto. Si cambias los camareros aquí, actualízala.
        </p>
      )}

      {/* La orden de personal extra con la sugerencia rellena (no cambia el número de camareros) */}
      {onAbrirSolicitud && (
        <button type="button" onClick={onAbrirSolicitud} className={`self-start ${enlace}`} data-testid="l2-camareros-anadir">
          Abrir la solicitud al proveedor
        </button>
      )}
    </div>
  );
};

export default CamarerosQuienVa;
